module.exports = __webpack_public_path__ + "img/服务协议首图.9e34496d.png";